<div class="ncis-GridActions-row">
  <button id="ncis-GridActions__details" mat-icon-button matTooltip="View Details" matTooltipPosition="above">
    <mat-icon id="ncis-GridActions__icon">visibility</mat-icon>
  </button>
</div>
